module.exports = __webpack_public_path__ + "0bfbbcbb2524abcd70b6799f1617f4ae.svg";